// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"4141c2bd","163":"5943aef4","453":"143507fe"}[chunkId] + ".chunk.js";
};